import React from "react";
import PropTypes from "prop-types";
import { Grid, IconButton, Modal, Typography } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import styles from "./ConformationModal.module.css";
import StyledButton from "../StyledButton/StyledButton";

import useStyles from "./ConformationModal.styles";

const ConformationModal = ({ open, handleConformation,  handleClose, message }) => {
  const classes = useStyles();

  return (
    <Modal
      open={open}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className={styles.container}>
        {/* Title Section */}
        <div className={styles.title}>
          <Typography className={styles.titleContent}>Alert</Typography>
          <IconButton
            className={styles.closeBtn}
            onClick={() => {
              handleClose();
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <div className={styles.content}>
          <Typography className={classes.message}>{message}</Typography>
        </div>

        <div
          style={{
            background: "#e2dfdf",
            padding: "16px",
            borderRadius: "20px",
          }}
        >
          <Grid
            container
            justifyContent="flex-end"
            alignItems="center"
            className={styles.buttonContainer}
          >
            <Grid item>
              <StyledButton
                color="primary"
                variant="contained"
                className={`${styles.button}  ${styles.submitBt}`}
                onClick={handleConformation}
              >
                Yes
              </StyledButton>
            </Grid>
            <Grid item>
              <StyledButton
                color="primary"
                variant="outlined"
                className={`${styles.button}  ${styles.cancelBt}`}
                onClick={handleClose}
              >
                No
              </StyledButton>
            </Grid>
          </Grid>
        </div>
      </div>
    </Modal>
  );
};

ConformationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleConformation: PropTypes.func,
  handleClose: PropTypes.func.isRequired,
  message: PropTypes.string,
};

export default ConformationModal;
